// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_4m-6";
export var headerCell = "_4m-2";
export var rowWrapper = "_4m-4";
export var stickyAggregationCell = "_4m-a";
export var stickyAggregationRow = "_4m-7";
export var stickyColumnCell = "_4m-9";
export var stickyColumnHeaderCell = "_4m-8";
export var table = "_4m-1";
export var virtualRowWrapper = "_4m-5";
export var virtualTableContainer = "_4m-0";
export var white = "_4m-3";